import { render, staticRenderFns } from "./InstanceEditSSO.vue?vue&type=template&id=4948689a&scoped=true&"
import script from "./InstanceEditSSO.vue?vue&type=script&lang=js&"
export * from "./InstanceEditSSO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4948689a",
  null
  
)

export default component.exports